import { render, staticRenderFns } from "./ModalAddPerson.vue?vue&type=template&id=4ee04c08&scoped=true"
import script from "./ModalAddPerson.vue?vue&type=script&lang=js"
export * from "./ModalAddPerson.vue?vue&type=script&lang=js"
import style0 from "./ModalAddPerson.vue?vue&type=style&index=0&id=4ee04c08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee04c08",
  null
  
)

export default component.exports